<template>

  <div id="page-datos-list">

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <flat-pickr :config="configdateTimePicker" v-model="fechas" placeholder="Rango de fechas..." />
          <vs-button icon-pack="feather" icon="icon-search" class="ml-4 mb-4 md:mb-0" @click="buscarDatos()" :disabled="!fechasVacio">Buscar datos</vs-button>
        </vs-row>        
        <vs-divider ></vs-divider>

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ datos.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : datos.length }} de {{ datos.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
          <vs-button icon-pack="feather" icon="icon-download" color="primary" type="border" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv({ allColumns: true })">Exportar a CSV</vs-button>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="datos"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>

  </div>

</template>

<script>
// Store Module
import operacionesStore from '@/store/gestion/operaciones/index.js'

import { AgGridVue } from 'ag-grid-vue'
import localeEs from '@/locale/aggrid/es.locale'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

// Cell Renderer
import CellRendererMoneda from '../cell-renderer/CellRendererMoneda.vue'

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererMoneda
  },
  props: {
    comercialId: Number
  },
  data () {
    return {
      searchQuery: '',

      //Flat Date Picker
      fechas: null,
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'range',
        defaultDate: null
      },

      // AgGrid
      gridApi: null,
      columnApi: null,
      gridOptions: {
        localeTextFunc (key, defaultValue) {          
          return localeEs[key] || defaultValue
        }
      },      
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Operación',
          headerTooltip: 'Operación',
          field: 'id',
          filter: true,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          type: 'numericColumn',
          width: 75
        },
        {
          headerName: 'Cliente',
          headerTooltip: 'Nombre del cliente',
          field: 'nombre',
          filter: true,
          width: 100,
          valueGetter (params) {
            if (params.data.apellidos === null || params.data.apellidos === undefined) {
              return params.data.nombre
            } else {
              return `${params.data.nombre} ${params.data.apellidos}`
            }
          }
        },
        { headerName: 'Fecha',
          headerTooltip: 'Fecha operación',
          field: 'fecha',
          width: 100,
          filter: 'agDateColumnFilter',
          filterParams: {
            filterOptions: ['inRange', 'equals', 'greaterThanOrEqual'],
            comparator (filterLocalDateAtMidnight, cellValue) {
              const dateAsString = cellValue
              if (dateAsString === null) return -1
              const dateParts = dateAsString.split('/')
              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              )
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) { return 0 }
              if (cellDate < filterLocalDateAtMidnight) { return -1 }
              if (cellDate > filterLocalDateAtMidnight) { return 1 }
            },
            browserDatePicker: true
          },
          valueGetter (params) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
            return params.data.fecha ? (new Date(params.data.fecha)).toLocaleDateString('es-ES', options) : ''
          }
        },
        {
          headerName: 'Estado',
          headerTooltip: 'Estado',
          field: 'estado_operacion',
          filter: true,
          width: 100
        },
        {
          headerName: 'Operador',
          headerTooltip: 'Operador',
          field: 'operador',
          filter: true,
          width: 100
        },
        {
          headerName: 'Tipo cliente',
          headerTooltip: 'Tipo cliente',
          field: 'tipo_cliente',
          filter: true,
          width: 100
        },
        {
          headerName: 'Producto',
          headerTooltip: 'Producto',
          field: 'producto',
          filter: true,
          width: 100
        },
        {
          headerName: 'Detalle',
          headerTooltip: 'Detalle producto',
          field: 'tarjeta',
          filter: true,
          width: 100
        },
        {
          headerName: 'Est. Producto',
          headerTooltip: 'Estado producto',
          field: 'estado_producto',
          filter: true,
          width: 100
        },
        { headerName: 'Fec. Instalación',
          headerTooltip: 'Fecha de instalación',
          field: 'fecha_instalacion',
          width: 100,
          filter: 'agDateColumnFilter',
          filterParams: {
            filterOptions: ['inRange', 'equals', 'greaterThanOrEqual'],
            comparator (filterLocalDateAtMidnight, cellValue) {
              const dateAsString = cellValue
              if (dateAsString === null) return -1
              const dateParts = dateAsString.split('/')
              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              )
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) { return 0 }
              if (cellDate < filterLocalDateAtMidnight) { return -1 }
              if (cellDate > filterLocalDateAtMidnight) { return 1 }
            },
            browserDatePicker: true
          },
          valueGetter (params) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
            return params.data.fecha_instalacion ? (new Date(params.data.fecha_instalacion)).toLocaleDateString('es-ES', options) : ''
          }
        },
        { headerName: 'Fec. Portabilidad',
          headerTooltip: 'Fecha de portabilidad',
          field: 'fecha_portabilidad',
          width: 100,
          filter: 'agDateColumnFilter',
          filterParams: {
            filterOptions: ['inRange', 'equals', 'greaterThanOrEqual'],
            comparator (filterLocalDateAtMidnight, cellValue) {
              const dateAsString = cellValue
              if (dateAsString === null) return -1
              const dateParts = dateAsString.split('/')
              const cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              )
              if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) { return 0 }
              if (cellDate < filterLocalDateAtMidnight) { return -1 }
              if (cellDate > filterLocalDateAtMidnight) { return 1 }
            },
            browserDatePicker: true
          },
          valueGetter (params) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
            return params.data.fecha_portabilidad ? (new Date(params.data.fecha_portabilidad)).toLocaleDateString('es-ES', options) : ''
          }
        },
        {
          headerName: 'Importe',
          headerTooltip: 'Importe',
          field: 'importe_con_promocion',
          filter: 'agNumberColumnFilter',
          cellRendererFramework: 'CellRendererMoneda',
          type: 'numericColumn',
          width: 100
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererMoneda
      }
    }
  },
  computed: {
    datos () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      const productos = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacionesProductos))
      // Poñemos a 0 os importes dos productos asociados ao producto principal para que non se repitan os importes
      productos.forEach(element => {
        if (element.seccion === 'PRODUCTO_PRINCIPAL' 
          && (element.tipo_tarjeta === 'COMBO' || element.tipo_tarjeta === 'COMBO_TV')
          && (element.tarjeta === 'MOVIL' || element.tarjeta === 'TV')
        ) {
          element.importe_con_promocion = 0
          element.tarjeta = `${element.tarjeta} PRODUCTO PRINCIPAL`
        }
      })
      return productos
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    fechasVacio () {
      return !((this.fechas === null || this.fechas === ''))
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'Todos', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async buscarDatos () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      const f = this.fechas.split(' a ')
      let fi = null
      let ff = null
      if (f.length === 1) {
        fi = ff = f[0]
      } else {
        fi = f[0]
        ff = f[1]
      }
      const params = {
        'consulta': 'operacionesProductos',
        'comercialId': this.comercialId,
        fi,
        ff
      }
      await this.$store.dispatch('operacionesStore/getOperaciones', params).catch(err => { console.error(err) })
      sessionStorage.setItem('comerciales_operaciones_fecha_inicio', fi)
      sessionStorage.setItem('comerciales_operaciones_fecha_fin', ff)
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    
    // Se xa se estivo traballando con datos, recuperamos o último conxunto de datos sobre o que se traballou
    const fiuc = sessionStorage.getItem('comerciales_operaciones_fecha_inicio')  // fiuc = fecha inicio última consulta
    const ffuc = sessionStorage.getItem('comerciales_operaciones_fecha_fin')  // ffuc = fecha fin última consulta

    if (fiuc !== null && fiuc !== null) {
      if (fiuc === ffuc) {
        this.fechas = fiuc.toString()
      } else {
        this.fechas = `${fiuc.toString()  } a ${ffuc.toString()}`
      }
      this.buscarDatos()
    } else {
      // Icialmente cargamos un mes a contar desde a data actual hacia atrás
      const cd = new Date()  // current date
      const month = new Date().setDate(cd.getDate() - 30)  // restamos 30 días desde a data de hoxe
      const id = new Date(month)  // initial date
      this.fechas = `${id.toISOString().substring(0, 10)} a ${cd.toISOString().substring(0, 10)}`
      sessionStorage.setItem('comerciales_operaciones_fecha_inicio', id.toISOString().substring(0, 10))
      sessionStorage.setItem('comerciales_operaciones_fecha_fin', cd.toISOString().substring(0, 10))
      this.buscarDatos()
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.gridApi.sizeColumnsToFit()
    const allColumnIds = []    
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId)
    })
    this.gridColumnApi.autoSizeColumns(allColumnIds, false)

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  }
}

</script>

<style lang="scss">
#page-datos-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>